/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LocationAdminSerializerInner } from './LocationAdminSerializerInner'
import {
  LocationAdminSerializerInnerFromJSON,
  LocationAdminSerializerInnerFromJSONTyped,
  LocationAdminSerializerInnerToJSON,
} from './LocationAdminSerializerInner'
import type { LocationTag } from './LocationTag'
import { LocationTagFromJSON, LocationTagFromJSONTyped, LocationTagToJSON } from './LocationTag'

/**
 *
 * @export
 * @interface Location
 */
export interface Location {
  /**
   *
   * @type {number}
   * @memberof Location
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof Location
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Location
   */
  declination?: string
  /**
   *
   * @type {LocationAdminSerializerInner}
   * @memberof Location
   */
  readonly region: LocationAdminSerializerInner
  /**
   *
   * @type {LocationTag}
   * @memberof Location
   */
  readonly tag: LocationTag
  /**
   *
   * @type {string}
   * @memberof Location
   */
  readonly locationSlug: string | null
}

/**
 * Check if a given object implements the Location interface.
 */
export function instanceOfLocation(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value
  isInstance = isInstance && 'region' in value
  isInstance = isInstance && 'tag' in value
  isInstance = isInstance && 'locationSlug' in value

  return isInstance
}

export function LocationFromJSON(json: any): Location {
  return LocationFromJSONTyped(json, false)
}

export function LocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Location {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    declination: !exists(json, 'declination') ? undefined : json['declination'],
    region: LocationAdminSerializerInnerFromJSON(json['region']),
    tag: LocationTagFromJSON(json['tag']),
    locationSlug: json['locationSlug'],
  }
}

export function LocationToJSON(value?: Location | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    declination: value.declination,
  }
}
